import { Spacings, TouchableOpacity } from "react-native-ui-lib";
import { cameraButtonStyles } from "../../constants";

export interface IconButtonProps {
  onPress?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export function IconButton({ onPress, children, disabled }: IconButtonProps) {
  return (
    <TouchableOpacity
      {...{ disabled, onPress }}
      style={{
        ...cameraButtonStyles,
        width: "48px",
        backgroundColor: disabled ? "#CCC" : "hsla(210, 76%, 58%, 0.4)",
      }}
    >
      {children}
    </TouchableOpacity>
  );
}
